var React = require('react');

function ToolsIconDesktopTablet (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#005F9E","d":"M0 0h129v129H0z","key":0}),React.createElement("path",{"d":"M85.737 78.49l-17.65-17.756c1.745-4.489.775-9.757-2.91-13.465-3.88-3.903-9.698-4.683-14.353-2.537l8.34 8.391-5.819 5.854-8.534-8.39c-2.327 4.683-1.358 10.537 2.522 14.44 3.685 3.707 8.922 4.683 13.383 2.927l17.65 17.757c.776.78 1.94.78 2.716 0l4.46-4.488c.97-.78.97-2.147.195-2.732z","fill":"#FFF","key":1})]));
}

ToolsIconDesktopTablet.displayName = "ToolsIconDesktopTablet";

ToolsIconDesktopTablet.defaultProps = {"width":"129","height":"129"};

module.exports = ToolsIconDesktopTablet;

ToolsIconDesktopTablet.default = ToolsIconDesktopTablet;
